// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ErrorReport from './ErrorReport';
//import registerServiceWorker from './registerServiceWorker';
import {unregister} from './registerServiceWorker';
import { CookiesProvider } from 'react-cookie';
//import { addLocaleData } from "react-intl";
//import locale_en from 'react-intl/locale-data/en';
//import locale_de from 'react-intl/locale-data/de';
// import messages_de from "./translations/de.json";
// import messages_en from "./translations/en.json";
//import i18n from './i18n';
import CookieStorageIntlProvider from "./components/CookieStorageIntlProvider"


// const messages = {
//     'de': messages_de,
//     'en': messages_en
// };
//addLocaleData([...locale_en, ...locale_de]);

ReactDOM.render(
    <Suspense fallback={<h2>Loading...</h2>}>
        <ErrorReport>
            <CookiesProvider>
                <CookieStorageIntlProvider initialLocale='en'>
                    <App />
                </CookieStorageIntlProvider>
            </CookiesProvider>
        </ErrorReport>
    </Suspense>
    , document.getElementById('gvlrgroot'));
//registerServiceWorker();
unregister();
